'use client';

import { ROUTES, meta } from '#/data/constants';
import Image from 'next/image';
import Link from 'next/link';

export default function BiComponent() {
  return (
    <div className="cursor-pointer">
      <Link className="sr-only" href={ROUTES.ANALYZE}>
        형태소 분석
      </Link>
      <Link className="sr-only" href={ROUTES.TOKENIZE}>
        단어 분절(토큰나이저)
      </Link>

      <Link className="w-8 h-8" href={ROUTES.CORRECT}>
        <span className="sr-only">바른 맞춤법 검사기</span>
        <Image
          src="/static/images/bareun-logo.webp"
          width={32}
          height={32}
          alt={meta.title}
          priority={true}
        />
      </Link>
    </div>
  );
}
